(function () {
    'use strict';

    angular
        .module('app.dailySetup')
        .directive('spDailySetup', spDailySetup)
        .directive('spEventsTable', spEventsTable)
        .directive('spTasksTable', spTasksTable);

    spDailySetup.$inject = ['reactDirective'];
    /* @ngInject */
    function spDailySetup(reactDirective) {
        return reactDirective(DailySetup);
    }

    spEventsTable.$inject = ['reactDirective'];
    /* @ngInject */
    function spEventsTable(reactDirective) {
        return reactDirective(EventsTable);
    }
    spTasksTable.$inject = ['reactDirective'];
    /* @ngInject */
    function spTasksTable(reactDirective) {
        return reactDirective(TasksTable);
    }
})();


